// @file vue composable for viewport intersection
import device from '@@/bits/device'
import { observeElementIntersection } from '@@/bits/intersection'
import { ref, watch, type Ref } from 'vue'

const useViewportIntersection = (
  el: Ref<HTMLElement | undefined>,
): {
  hasIntersectedViewport: Ref<boolean>
} => {
  // 2022, Sep 22: observing intersection does not work for custom domain opened in an iframe in safari on mac/all browsers in iOS
  // => don't do it in those cases and just assume this component always intersects with the viewport. There'll be performance impact but it's better than things not loaded at all
  const isDisplayedInIframe = window.self !== window.top
  const isIframeInSafari = isDisplayedInIframe && (device.safari || device.ios)
  const hasIntersectedViewport = ref(isIframeInSafari)

  let observer: IntersectionObserver | null = null
  watch(
    el,
    () => {
      if (observer != null) {
        observer.disconnect()
      }

      if (!hasIntersectedViewport.value && el.value != null) {
        observer = observeElementIntersection(el.value, () => {
          hasIntersectedViewport.value = true
        })
      }
    },
    { immediate: true },
  )

  return {
    hasIntersectedViewport,
  }
}

export default useViewportIntersection
